import { prevUser } from "./context/userContect";

// Fetch Hugging Face API keys from environment variables
const API_KEYS = [
	"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",
	"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",
	"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",
	"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",
	"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",
	"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"
].filter(key => key && key.trim() !== ''); // Filter out empty/undefined keys

// console.log(`Hugging Face API: ${API_KEYS.length} keys loaded`);

// Validate API keys
if (API_KEYS.length === 0) {
	console.error("No Hugging Face API keys found! Please check your .env file.");
	throw new Error("No Hugging Face API keys configured. Please add your API keys to the .env file.");
}

// Log available keys (masked for security)
// API_KEYS.forEach((key, index) => {
// 	if (key && key.startsWith('hf_')) {
// 		console.log(`Hugging Face API Key ${index + 1}: ${key.substring(0, 10)}...`);
// 	} else {
// 		console.warn(`Hugging Face API Key ${index + 1}: Invalid format (should start with 'hf_')`);
// 	}
// });

let currentKeyIndex = 0;

// Function to switch to the next API key
function switchToNextApiKey() {
	if (currentKeyIndex < API_KEYS.length - 1) {
		currentKeyIndex++;
		// console.log(`Switching to API key ${currentKeyIndex + 1}`);
		return true;
	}
	return false;
}

// Function to get image dimensions based on aspect ratio
function getImageDimensions(aspectRatio) {
	switch (aspectRatio) {
		case "1:1":
			return { width: 1024, height: 1024 };
		case "16:9":
			return { width: 1280, height: 720 };
		case "9:16":
			return { width: 720, height: 1280 };
		default:
			return { width: 1024, height: 1024 };
	}
}

export async function query(prompt, imageData, aspectRatio = "1:1", numImages = 1, progressCallback = null) {
	const dimensions = getImageDimensions(aspectRatio);
	let attempts = 0;
	const maxAttempts = API_KEYS.length;

	while (attempts < maxAttempts) {
		try {
			// console.log(`Trying Hugging Face API with key ${currentKeyIndex + 1}/${API_KEYS.length}`);
			
			// Generate multiple unique images by making separate API calls
			const images = [];
			
			for (let i = 0; i < numImages; i++) {
				console.log(`Generating image ${i + 1}/${numImages} with Hugging Face SDXL...`);
				
				// Call progress callback if provided
				if (progressCallback) {
					progressCallback(`Generating image ${i + 1} of ${numImages}...`);
				}
				
				// Add variation to prompt for different images
				const variedPrompt = numImages > 1 ? 
					`${imageData ? imageData.prompt || prompt : prompt}, variation ${i + 1}, unique style` : 
					(imageData ? imageData.prompt || prompt : prompt);
				
				const response = await fetch(
					"https://api-inference.huggingface.co/models/stabilityai/stable-diffusion-xl-base-1.0",
					{
						headers: {
							Authorization: `Bearer ${API_KEYS[currentKeyIndex]}`,
							"Content-Type": "application/json",
						},
						method: "POST",
						body: JSON.stringify({
							inputs: imageData
								? {
										image: imageData,
										prompt: variedPrompt,
								  }
								: variedPrompt,
							parameters: {
								guidance_scale: 7.5 + (Math.random() * 2.5), // Add slight randomness
								num_inference_steps: 50,
								strength: 0.75 + (Math.random() * 0.2 - 0.1), // Add slight variation
								width: dimensions.width,
								height: dimensions.height,
								num_images_per_prompt: 1, // Always generate 1 per call
								seed: Math.floor(Math.random() * 1000000), // Random seed for variation
							},
						}),
					}
				);

				if (!response.ok) {
					const errorText = await response.text();
					console.error(`Hugging Face API Error ${response.status} for image ${i + 1}:`, errorText);
					throw new Error(`API Error ${response.status}: ${errorText || 'Unknown error'}`);
				}

				const result = await response.blob();
				images.push(result);
				
				// Add small delay between requests to avoid rate limiting
				if (i < numImages - 1) {
					await new Promise(resolve => setTimeout(resolve, 500));
				}
			}
			
			return { images };
		} catch (error) {
			console.error(`Hugging Face API error with key ${currentKeyIndex + 1}/${API_KEYS.length}:`, error);
			// console.log(`Current API key: ${API_KEYS[currentKeyIndex]?.substring(0, 10)}...`);
			attempts++;

			if (!switchToNextApiKey()) {
				console.error("All Hugging Face API keys failed. Keys available:", API_KEYS.length);
				throw new Error(`All Hugging Face API keys failed after ${attempts} attempts. Please check your API keys.`);
			}
		}
	}
	throw new Error(`Failed to generate images after trying all ${API_KEYS.length} Hugging Face API keys.`);
}
